module.exports = __webpack_public_path__ + "static/media/p0_0.8e13a162.png";